var _defs, _rect, _rect2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgForestDots(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 320 200",
    preserveAspectRatio: "xMidYMid slice",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "bgForest",
    x1: 0,
    y1: 0,
    x2: 1,
    y2: 1
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    stopColor: "#142e22"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    stopColor: "#2a5b41"
  })), /*#__PURE__*/React.createElement("pattern", {
    id: "dotsForest",
    width: 16,
    height: 16,
    patternUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 4,
    cy: 4,
    r: 1.4,
    fill: "#ffffff",
    fillOpacity: 0.1
  })))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 320,
    height: 200,
    fill: "url(#bgForest)"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    width: 320,
    height: 200,
    fill: "url(#dotsForest)"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgForestDots);
export default __webpack_public_path__ + "static/media/forest-dots.7ca3132538b36663885187b808e745f1.svg";
export { ForwardRef as ReactComponent };